import { Company } from '@/repositories/system/data'
import { Axios } from 'axios'

export type RequestParam = {
  name: string;
  isAvailable: boolean;
}

export interface CompanyRepository {
  list(): Promise<Company[]>;
  get(key: string): Promise<Company>;
  add(request: RequestParam): Promise<Company>;
  modify(key: string, request: RequestParam): Promise<Company>;
  delete(key: string): Promise<void>;
}

export class CompanyRepositoryImpl implements CompanyRepository {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios
  private readonly baseUrl = 'system/company'

  async list (): Promise<Company[]> {
    const { data } = await this.http.get(this.baseUrl)
    return data
  }

  async get (key: string): Promise<Company> {
    const { data } = await this.http.get(`${this.baseUrl}/${key}`)
    return data
  }

  async add (request: RequestParam): Promise<Company> {
    const { data } = await this.http.post(this.baseUrl, request)
    return data
  }

  async modify (key: string, request: RequestParam): Promise<Company> {
    const { data } = await this.http.put(`${this.baseUrl}/${key}`, request)
    return data
  }

  async delete (key: string): Promise<void> {
    await this.http.delete(`${this.baseUrl}/${key}`)
  }
}
